import { useMemo, useCallback } from "react";
import { usePermissions } from "../contexts/permissions";
import getDashboardLink from "../utils/getDashboardLink";
import useSelectionContext from "./useSelectionContext";

export function useDynamicDashboardLink() {
  const { can, user, settings } = usePermissions();
  const { selectionContext } = useSelectionContext();
  const warehouseDropdownEnabled = Boolean(settings?.warehouse_id_dropdown_menu);

  return useCallback(() => {
    const link = getDashboardLink(selectionContext, { warehouseDropdownEnabled });

    if (!user || !link) {
      return link || "/";
    }

    const hasAccessToCaptureInventory = can("features.capture_inventory");
    const hasAccessToAssets = can("pages.dashboard");

    if (!hasAccessToCaptureInventory && hasAccessToAssets) {
      return link.replace("capture-inventory", "assets");
    }

    return link;
  }, [can, selectionContext, user, warehouseDropdownEnabled]);
}

export default function useDashboardLink() {
  const getDashboardLinkDynamic = useDynamicDashboardLink();

  const dashboardLink = useMemo(() => getDashboardLinkDynamic(), [getDashboardLinkDynamic]);

  return dashboardLink;
}
